export enum ChoghadiyaNames {
  amrit = 'Amrit', // good choghadiya
  chal = 'Chal', // good choghadiya
  kaal = 'Kaal', // bad choghadiya
  labh = 'Labh', // good choghadiya
  rog = 'Rog', // bad choghadiya
  shubh = 'Shubh', // good choghadiya
  udveg = 'Udveg', // bad choghadiya
}

// Assume 0 - 6 day where Sunday = 0, ... Saturday = 6
export const dayTimeChoghadiya = [
  {
    day: 'Sunday',
    choghadiyas: [
      ChoghadiyaNames.udveg,
      ChoghadiyaNames.chal,
      ChoghadiyaNames.labh,
      ChoghadiyaNames.amrit,
      ChoghadiyaNames.kaal,
      ChoghadiyaNames.shubh,
      ChoghadiyaNames.rog,
      ChoghadiyaNames.udveg,
    ],
  },
  {
    day: 'Monday',
    choghadiyas: [
      ChoghadiyaNames.amrit,
      ChoghadiyaNames.kaal,
      ChoghadiyaNames.shubh,
      ChoghadiyaNames.rog,
      ChoghadiyaNames.udveg,
      ChoghadiyaNames.chal,
      ChoghadiyaNames.labh,
      ChoghadiyaNames.amrit,
    ],
  },
  {
    day: 'Tuesday',
    choghadiyas: [
      ChoghadiyaNames.rog,
      ChoghadiyaNames.udveg,
      ChoghadiyaNames.chal,
      ChoghadiyaNames.labh,
      ChoghadiyaNames.amrit,
      ChoghadiyaNames.kaal,
      ChoghadiyaNames.shubh,
      ChoghadiyaNames.rog,
    ],
  },
  {
    day: 'Wednesday',
    choghadiyas: [
      ChoghadiyaNames.labh,
      ChoghadiyaNames.amrit,
      ChoghadiyaNames.kaal,
      ChoghadiyaNames.shubh,
      ChoghadiyaNames.rog,
      ChoghadiyaNames.udveg,
      ChoghadiyaNames.chal,
      ChoghadiyaNames.labh,
    ],
  },
  {
    day: 'Thursday',
    choghadiyas: [
      ChoghadiyaNames.shubh,
      ChoghadiyaNames.rog,
      ChoghadiyaNames.udveg,
      ChoghadiyaNames.chal,
      ChoghadiyaNames.labh,
      ChoghadiyaNames.amrit,
      ChoghadiyaNames.kaal,
      ChoghadiyaNames.shubh,
    ],
  },
  {
    day: 'Friday',
    choghadiyas: [
      ChoghadiyaNames.chal,
      ChoghadiyaNames.labh,
      ChoghadiyaNames.amrit,
      ChoghadiyaNames.kaal,
      ChoghadiyaNames.shubh,
      ChoghadiyaNames.rog,
      ChoghadiyaNames.udveg,
      ChoghadiyaNames.chal,
    ],
  },
  {
    day: 'Saturday',
    choghadiyas: [
      ChoghadiyaNames.kaal,
      ChoghadiyaNames.shubh,
      ChoghadiyaNames.rog,
      ChoghadiyaNames.udveg,
      ChoghadiyaNames.chal,
      ChoghadiyaNames.labh,
      ChoghadiyaNames.amrit,
      ChoghadiyaNames.kaal,
    ],
  },
];

// Assume 0 - 6 day where Sunday = 0, ... Saturday = 6
export const nightTimeChoghadiya = [
  {
    day: 'Sunday',
    choghadiyas: [
      ChoghadiyaNames.shubh,
      ChoghadiyaNames.amrit,
      ChoghadiyaNames.chal,
      ChoghadiyaNames.rog,
      ChoghadiyaNames.kaal,
      ChoghadiyaNames.labh,
      ChoghadiyaNames.udveg,
      ChoghadiyaNames.shubh,
    ],
  },
  {
    day: 'Monday',
    choghadiyas: [
      ChoghadiyaNames.chal,
      ChoghadiyaNames.rog,
      ChoghadiyaNames.kaal,
      ChoghadiyaNames.labh,
      ChoghadiyaNames.udveg,
      ChoghadiyaNames.shubh,
      ChoghadiyaNames.amrit,
      ChoghadiyaNames.chal,
    ],
  },
  {
    day: 'Tuesday',
    choghadiyas: [
      ChoghadiyaNames.kaal,
      ChoghadiyaNames.labh,
      ChoghadiyaNames.udveg,
      ChoghadiyaNames.shubh,
      ChoghadiyaNames.amrit,
      ChoghadiyaNames.chal,
      ChoghadiyaNames.rog,
      ChoghadiyaNames.kaal,
    ],
  },
  {
    day: 'Wednesday',
    choghadiyas: [
      ChoghadiyaNames.udveg,
      ChoghadiyaNames.shubh,
      ChoghadiyaNames.amrit,
      ChoghadiyaNames.chal,
      ChoghadiyaNames.rog,
      ChoghadiyaNames.kaal,
      ChoghadiyaNames.labh,
      ChoghadiyaNames.udveg,
    ],
  },
  {
    day: 'Thursday',
    choghadiyas: [
      ChoghadiyaNames.amrit,
      ChoghadiyaNames.chal,
      ChoghadiyaNames.rog,
      ChoghadiyaNames.kaal,
      ChoghadiyaNames.labh,
      ChoghadiyaNames.udveg,
      ChoghadiyaNames.shubh,
      ChoghadiyaNames.amrit,
    ],
  },
  {
    day: 'Friday',
    choghadiyas: [
      ChoghadiyaNames.rog,
      ChoghadiyaNames.kaal,
      ChoghadiyaNames.labh,
      ChoghadiyaNames.udveg,
      ChoghadiyaNames.shubh,
      ChoghadiyaNames.amrit,
      ChoghadiyaNames.chal,
      ChoghadiyaNames.rog,
    ],
  },
  {
    day: 'Saturday',
    choghadiyas: [
      ChoghadiyaNames.labh,
      ChoghadiyaNames.udveg,
      ChoghadiyaNames.shubh,
      ChoghadiyaNames.amrit,
      ChoghadiyaNames.chal,
      ChoghadiyaNames.rog,
      ChoghadiyaNames.kaal,
      ChoghadiyaNames.labh,
    ],
  },
];
